export default {
  /** connect by creating an account or by login
   *  @param method (login|registration)
   * */
  connect: async function (method = 'login') {
    await window.axios.post(window.routes[method], this[method])
      .then(response => {
        this.is_connected = response.status === 204
        this.next()
        /** delete step registration since it's not needed anymore */
        this.order_steps.splice(this.order_steps.indexOf('accountRegistration'), 1)
        this.visibleToastr.push(this.toastr[method].name)
        /** update csrf since session is being reloaded after login */
        window.axios.defaults.headers.post['X-CSRF-TOKEN'] = response.data.csrf
      })
      .catch(err => {
        this.registrationErrors = err.response.data.errors
      })
  },

  changeMethod (method = 'login') {
    this.registrationMethod = method
  }
}
